// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2qurL","approved":"Status_approved__2Kp8C","rejected":"Status_rejected__PZsx0","expired":"Status_expired__gxBch","label":"Status_label__3Nf04"};